import { useEffect } from 'react';

import { getUtmData } from '@/utils/user-tracking-data';

/**
 * Hook to automatically save UTM parameters from URL to sessionStorage
 * Should be used in _app.tsx to ensure UTM data is captured on every page load
 */
export const useUtmTracker = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    // This will extract UTM from URL and save to sessionStorage if present
    getUtmData();
  }, [enabled]);
};
